const validateLmaNumber = (lmaNumber, birthDate) => {
    if (lmaNumber === "" && birthDate === "") {
        return  true;
    }
    let pattern = /^[0-9]{8}$/;
    return pattern.test(lmaNumber);
};

export default validateLmaNumber;